export default __webpack_public_path__ + "static/media/blockdate.0809924f.svg";